import React from 'react';

import { TextField, styled } from '@gogame/components';

import {
  useSocketHighlightColor,
  useSocketBlurEmitter,
  useSocketFocusEmitter,
} from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Socket/hooks';

import useMountedFocus from './useMountedFocus';

// eslint-disable-next-line no-unused-vars
const StyledTextField = styled(({ boxShadow: _, ...props }) => (
  <TextField {...props} />
))`
  input {
    border-radius: 4px;
    box-shadow: ${({ boxShadow }) => boxShadow};
  }
`;

export const HighLightTextField = ({ path, ...props }) => {
  const handleFocus = useSocketFocusEmitter({
    path: path,
  });
  const handleBlur = useSocketBlurEmitter({
    path: path,
  });
  const color = useSocketHighlightColor({
    path: path,
  });

  const { onFocus, onBlur } = useMountedFocus({
    onFocus: handleFocus,
    onBlur: handleBlur,
  });

  return (
    <StyledTextField
      onFocus={onFocus}
      onBlur={onBlur}
      boxShadow={color ? `0 0 0 1px ${color}` : 'none'}
      disabled={!!color}
      {...props}
    />
  );
};
